import { render, staticRenderFns } from "./confirm-task-dialog.vue?vue&type=template&id=ef1c29b4&"
import script from "./confirm-task-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-task-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports